import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ItemTypes } from '../types';
import { useDrag } from 'react-dnd';
import Paper from '@mui/material/Paper';
import { Typography } from '@totalsoft/rocket-ui';
import { Grid } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { boxShadow } from '../bulkUpload/functions';
import { useHover } from '../bulkUpload/useHover';

const style = {
  padding: '0',
  margin: '0.2rem',
  float: 'left',
  maxWidth: 130,
  minWidth: 130,
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  fontSize: 'small'
};

export const ThumbBox = ({ item, onPreview, onSelectionChange, setSelectedFiles }) => {
  const { isHovered, handleMouseEnter, handleMouseLeave } = useHover();
  const { name } = item;
  const [{ opacity }, drag] = useDrag(
    () => ({
      type: ItemTypes.PAGE,
      item,
      collect: monitor => ({
        opacity: monitor.isDragging() ? 0.6 : 1
      }),
      end: () => setSelectedFiles([])
    }),
    [name]
  );

  const handleThumbBoxClick = event => {
    if (event.ctrlKey) {
      onSelectionChange(item);
    } else if (event.shiftKey) {
      onSelectionChange(item, true);
    } else {
      handleOnPreview();
    }
  };

  const handleOnPreview = useCallback(() => {
    onPreview(item, false);
  }, [item, onPreview]);

  return (
    <div ref={drag} style={{ ...style, opacity }}>
      <Grid container justifyContent='space-between' alignItems='center' px={1}>
        <Typography align='left'>P{item?.page}</Typography>
      </Grid>
      <div onClick={handleThumbBoxClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ position: 'relative' }}>
        <Paper
          title={`${item?.file} - P${item?.page}`}
          style={{
            marginRight: 10,
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: boxShadow(item.addedToComposeDoc, item.selected),
            filter: isHovered ? 'blur(3px)' : 'none',
            opacity: isHovered ? 0.8 : 1,
            cursor: isHovered ? 'pointer' : 'default'
          }}
        >
          {item?.name}
        </Paper>
        {isHovered && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1,
              cursor: 'pointer'
            }}
          >
            <Visibility />
          </div>
        )}
      </div>
      <Typography title={item?.fileName} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
        {item?.fileName}
      </Typography>
    </div>
  );
};

ThumbBox.propTypes = {
  item: PropTypes.object,
  onPreview: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  setSelectedFiles: PropTypes.func.isRequired
};
